import clsx from 'clsx'
import React, { FC } from 'react'

import Truck from '@Assets/SVG/Truck'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { PageType } from '@Generated/graphql'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { useTranslation } from '@Globals/Translations'

import styles from './DeliveryCartField.module.scss'

export interface DeliveryCartFieldProps {
  className?: string
  expectedDelivery: string
  hideButton?: boolean
  iconClassName?: string
  inline?: boolean
  v2?: boolean
}

export const DeliveryCartField: FC<DeliveryCartFieldProps> = ({ className, expectedDelivery, hideButton, iconClassName, inline = false, v2 = false }) => {
  const { t } = useTranslation('shipping')
  const openModal = useCMSModalOpen()
  const openShippingOptions = () => openModal(PageType.Modal, '20', 'cart')
  const days = expectedDelivery.indexOf('-') !== -1
    ? t('cart:X_WEEKDAYS', `${expectedDelivery} working days`, { arg1: expectedDelivery })
    : t('cart:ONE_WEEKDAY')

  if (inline) {
    return (
      <button className={clsx(styles.inline, className)} onClick={openShippingOptions} type="button">
        {`(${days})`}
      </button>
    )
  }

  if (v2) {
    return (
      <div className={clsx(styles.deliveryCartField, v2 && styles.v2, className)}>
        <span>
          {`${t('cart:EXPECTED_DELIVERY_LABEL')} `}
          <span>
            {days}
            {' '}
          </span>
        </span>
        {' '}
        {!hideButton && (
          <button onClick={openShippingOptions} type="button">
            {t('header:SEE_SHIPPING_OPTIONS')}
          </button>
        )}
      </div>
    )
  }

  return (
    <div className={clsx(styles.deliveryCartField, className)}>
      <SVGIcon className={clsx(styles.icon, iconClassName)} icon={Truck} />
      <span>
        {`${t('cart:EXPECTED_DELIVERY_LABEL')} `}
        <span>
          {days}
          {' '}
        </span>
      </span>
      {' '}
      {!hideButton && (
        <button onClick={openShippingOptions} type="button">
          {t('header:SEE_SHIPPING_OPTIONS')}
        </button>
      )}
    </div>
  )
}

